import React from "react";

export default function Signup() {
  return <div className="text-white">comming soon</div>;
}
